import React, {useEffect, useMemo, useState} from "react";
import NavBar from "../../../common/NavBar";
import SideBar from "../../../common/SideBar";
import {Link} from "react-router-dom";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CssBaseline from "@material-ui/core/CssBaseline";
import AccidentEnhancedTable from "./accidentProductsTableComponent/EnhancedTable";
import SavingsEnhancedTable from "./savingsProductsTableComponent/EnhancedTable";
import NhakaYanguEnhancedTable from './nhakaYanguProductsTableComponent/EnhancedTable';
import FuneralEnhancedTable from "./funeralProductsTableComponent/EnhancedTable";
import ComprehensiveEnhancedTable from "./comprehensiveTableComponent/EnhancedTable";
import ProductsService from "../../../services/ProductsService";
import Spinner from "reactjs-simple-spinner";
import TextField from "@material-ui/core/TextField";
import SettingsService from "../../../services/SettingsService";


const ViewPackages = (props) => {

    const accidentColumns = useMemo(
        () => [
            {
                Header: 'ID',
                accessor: 'id',
            },
            {
                Header: 'Sum Assured',
                accessor: 'sum_assured',
            },
            {
                Header: 'Premium',
                accessor: 'premium'
            },
            {
                Header: 'Clawback Period',
                accessor: 'clawback_period'
            },
            //            {
            //                Header: 'Action',
            //                accessor: 'id',
            //                Cell: ({value}) => (
            //                    <span>
            // <Link className="anchor-size text-primary " onClick={() => openEditForm(value)}>Edit <i className="fa fa-edit" /></Link>
            //                    </span>
            //                )
            //            },
        ],
        []
    )

    const savingsColumns = useMemo(
        () => [
            {
                Header: 'ID',
                accessor: 'id',
            },
            {
                Header: 'Monthly Investment Premium',
                accessor: 'monthly_investments_premium',
            },

            {
                Header: 'Clawback Period',
                accessor: 'clawback_period'
            }
        ],
        []
    )

    const nhakaYanguColumns = useMemo(
        () => [
            {
                Header: 'ID',
                accessor: 'id',
            },
            {
                Header: 'Monthly Investment Premium',
                accessor: 'monthly_investments_premium',
            },
            {
                Header: 'Cows After Maturity',
                accessor: 'cows_after_maturity'
            },
            {
                Header: 'Calf After Maturity',
                accessor: 'calf_after_maturity'
            }
        ],
        []
    )

    const comprehensiveColumns = useMemo(
        () => [
            {
                Header: 'ID',
                accessor: 'id',
            },
            {
                Header: 'Sum Assured',
                accessor: 'sum_assured',
            },
            {
                Header: 'Premium',
                accessor: 'premium'
            },
            {
                Header: 'Term',
                accessor: 'term'
            },
            {
                Header: 'Clawback Period',
                accessor: 'clawback_period'
            },
            //            {
            //                Header: 'Action',
            //                accessor: 'id',
            //                Cell: ({value}) => (
            //                    <span>
            // <Link className="anchor-size text-primary " onClick={() => openEditForm(value)}>Edit <i className="fa fa-edit" /></Link>
            //                    </span>
            //                )
            //            },
        ],
        []
    )




    const [data, setData] = useState([])
    const [product, setProduct] = useState('');
    const [skipPageReset, setSkipPageReset] = useState(false)
    // const [productName, setProductName] = useState('');
    const [loading, setLoading] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);

    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    // till here end

    useEffect(() => {
        setLoading(true);
        setUpdateLoading(false);
        const productId = JSON.parse(localStorage.getItem('productId'));
        // setProductName(productId);
        console.log("productPackages: ", productId);

        // getProductDetails - productId store in local storage is sent to the api endpoint
        // to retrieve packages
        ProductsService.getProductDetails()
            .then(res => {
                if (res.status === 200) {
                    // console.log("product",res.data.product);
                    setProduct(res.data.product);

                    ProductsService.getAllProductPackages()
                        .then(res => {
                            if (res.status === 200) {
                                console.log("packages", res);
                                console.log("product", product);
                                setData(res.data.packages);
                                setLoading(false);
                            } else {
                                setData([]);
                                setLoading(false);
                            }

                        })
                        .catch(err => {
                            setData([]);
                            setLoading(false);
                            console.log(err)
                            toast.warning('Operation Failed, Reload Page\nIf error persists contact System Administrator ')
                        });
                } else {
                    setData([]);
                    setLoading(false);
                }

            })
            .catch(err => {
                setProduct([]);
                console.log(err)
                toast.warning('Failed To Load Product, Reload Page\nIf error persists contact System Administrator ')
            });

    },[])

    const updateLockInPeriod = () => {
        setUpdateLoading(true);
        console.log(product);

        console.log("request payload: ", product);

        ProductsService.updateProduct(product).then(res => {
            console.log("res: ", res)
            if (res.status === 200) {
                ProductsService.getProductDetails().then(response => {
                    console.log(response);
                    if (response === undefined) {

                        toast.warning('✅ Lock in period before withdrawal updated, 🚫 Failed to get data ', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setUpdateLoading(false);
                    }

                    setProduct(res.data.product);
                    ProductsService.getAllProductPackages()
                        .then(res => {
                            if (res.status === 200) {
                                console.log("packages", res);
                                console.log("product", product);
                                setData(res.data.packages);
                                toast('✅ Lock in period before withdrawal updated successful', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                setLoading(false);
                                setUpdateLoading(false);
                            } else {
                                setData([]);
                                toast.warning('✅ Lock in period before withdrawal updated, Failed to get product packages, Reload Page\n and If error persists contact System Administrator ')
                                setLoading(false);
                                setUpdateLoading(false);
                            }

                        })
                        .catch(err => {
                            setData([]);
                            setLoading(false);
                            setUpdateLoading(false);
                            console.log(err)
                            toast.warning('✅ Lock in period before withdrawal updated, Failed to get product packages, Reload Page\n and If error persists contact System Administrator ')
                        });


                    setUpdateLoading(false);

                    //   console.log();                                                                                        );
                }).catch(err => {
                    console.log(err);
                    toast.warning('✅ Lock in period before withdrawal updated , 🚫 Failed to get data ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);
                });

            } else {
                toast.warning('🚫 Failed to update lock in period before withdrawal ' + res.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            }
        })
            .catch((err) => {
                console.log("error: ", err)
                toast.warning('🚫 Failed to update lock in period before withdrawal ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            })

    }

    return(
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            {loading && (
                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                    <Spinner
                        size="large"
                        message="Loading Packages..."
                        line-fg-color="#64c3c2"
                    />
                </div>
            )}
            {updateLoading && (
                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                    <Spinner
                        size="large"
                        message="Updating setting, Please wait....."
                        line-fg-color="#64c3c2"
                    />
                </div>
            )}

            {!loading && !updateLoading && (
                <div id="main-content" className="main-panel ps-container ps-theme-default">
                  <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                    <div className="content">
                        <div className="container-fluid">
                            <ul className="breadcrumb">
                                <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                                 &nbsp;|&nbsp;
                                <Link to="/products">
                                    <a href>Products </a>
                                </Link>
                                 &nbsp;|&nbsp;
                                <span className="text-capitalize">{product.name} Packages</span>
                            </ul>
                            <div className="row mt">
                                <div className="col-lg-12">
                                    <div className="content-panel">
                                        {product.name === 'ACCIDENT' && (
                                            <div id="table" style={{backgroundColor: "#fff"}}>
                                                <CssBaseline/>
                                                <AccidentEnhancedTable
                                                    columns={accidentColumns}
                                                    data={data}
                                                    setData={setData}
                                                    updateMyData={updateMyData}
                                                    skipPageReset={skipPageReset}
                                                />
                                            </div>
                                        )
                                        }

                                        {product.name === 'FUNERAL' && (
                                            <div id="table" style={{backgroundColor: "#fff"}}>
                                                <CssBaseline/>
                                                <FuneralEnhancedTable
                                                    columns={comprehensiveColumns}
                                                    data={data}
                                                    setData={setData}
                                                    updateMyData={updateMyData}
                                                    skipPageReset={skipPageReset}
                                                />
                                            </div>
                                        )

                                        }
                                        {product.name === 'COMPREHENSIVE' && (
                                            <div id="table" style={{backgroundColor: "#fff"}}>
                                                <CssBaseline/>
                                                <ComprehensiveEnhancedTable
                                                    columns={comprehensiveColumns}
                                                    data={data}
                                                    setData={setData}
                                                    updateMyData={updateMyData}
                                                    skipPageReset={skipPageReset}
                                                />
                                            </div>
                                        )

                                        }
                                        {product.name === 'SAVINGS' && (
                                            <>
                                                <div id="table" style={{backgroundColor: "#fff"}}>
                                                    <CssBaseline/>
                                                    <SavingsEnhancedTable
                                                        columns={savingsColumns}
                                                        data={data}
                                                        setData={setData}
                                                        updateMyData={updateMyData}
                                                        skipPageReset={skipPageReset}
                                                    />
                                                </div>
                                                <hr/>
                                                <div className="row gutters-sm">
                                                    <div className="container col-md-6">
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <div className="d-flex flex-column align-items-center text-center">
                                                                    <h2 className="text-primary h2">Update Lock In Period Before Withdrawal</h2>
                                                                    <div className="mt-3">
                                                                        <h4>Current Lock In Period</h4>
                                                                        <label className="text-success mb-1">{ product.lock_in_period_before_withdrawal} months</label>
                                                                    </div>
                                                                    <hr/>
                                                                    <div className="mt-2">
                                                                        <label htmlFor="">Lock in period before withdrawal</label>
                                                                        <TextField
                                                                            type="number"
                                                                            autoComplete="off"
                                                                            aria-autocomplete={false}
                                                                            className="mb-3 col-12"
                                                                            fullWidth
                                                                            required
                                                                            name="lock_in_period_before_withdrawal"
                                                                            value={product.lock_in_period_before_withdrawal}
                                                                            onChange={(e) => setProduct((prevState) => ({
                                                                                    ...prevState,
                                                                                    id: product.id,
                                                                                    lock_in_period_before_withdrawal: parseInt(e.target.value)
                                                                                })
                                                                            )}
                                                                        />
                                                                    </div>
                                                                    <button
                                                                        onClick={updateLockInPeriod}
                                                                        className="btn btn-sm btn-primary">
                                                                        Save Changes
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )

                                        }
                                        {product.name === 'PFUMA / INOTHO' && (
                                            <>
                                                <div id="table" style={{backgroundColor: "#fff"}}>
                                                    <CssBaseline/>
                                                    <NhakaYanguEnhancedTable
                                                        columns={nhakaYanguColumns}
                                                        data={data}
                                                        setData={setData}
                                                        updateMyData={updateMyData}
                                                        skipPageReset={skipPageReset}
                                                    />
                                                </div>
                                                <hr/>
                                                <div className="row gutters-sm">
                                                    <div className="container col-md-6">
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <div className="d-flex flex-column align-items-center text-center">
                                                                    <h2 className="text-primary h2">Update Lock In Period Before Withdrawal</h2>
                                                                    <div className="mt-3">
                                                                        <h4>Current Lock In Period</h4>
                                                                        <label className="text-success mb-1">{ product.lock_in_period_before_withdrawal} months</label>
                                                                    </div>
                                                                    <hr/>
                                                                    <div className="mt-2">
                                                                        <label htmlFor="">Lock in period before withdrawal</label>
                                                                        <TextField
                                                                            type="number"
                                                                            autoComplete="off"
                                                                            aria-autocomplete={false}
                                                                            className="mb-3 col-12"
                                                                            fullWidth
                                                                            required
                                                                            name="lock_in_period_before_withdrawal"
                                                                           value={product.lock_in_period_before_withdrawal}
                                                                            onChange={(e) => setProduct((prevState) => ({
                                                                                ...prevState,
                                                                                    id: product.id,
                                                                                    lock_in_period_before_withdrawal: parseInt(e.target.value)
                                                                            })
                                                                            )}
                                                                        />
                                                                    </div>
                                                                    <button
                                                                        onClick={updateLockInPeriod}
                                                                        className="btn btn-sm btn-primary">
                                                                        Save Changes
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>

                                        )

                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ViewPackages;
